import { post } from '@/utils/client';
import { useSWRConfig } from 'swr';
import { useRouter } from 'next/router';
import { LOGOUT, USER } from '@/routes/apiEndpoints';
import mixpanel from 'mixpanel-browser';

import type { UserType } from '@/types/userType';

const useLogout = () => {
    const { mutate } = useSWRConfig();
    const router = useRouter();
    const logout = async () => {
        try {
            await post(LOGOUT);
            await mutate<UserType>(USER, undefined);
            //reset mixpanel user
            mixpanel.reset();
            router.push('/');
        } catch (e) {
            console.error(e);
            // Logout fail
        }
    };

    return { logout };
};

export default useLogout;
